import "./RaceTab.css";

import React from "react";
import { IRpgRace } from "../../../models/IRpgRace";
import RaceSelectionCard from "../../../components/Race/RaceSelectionCard";
import RaceDetailsPanel from "../../../components/Race/RaceDetailsPanel";

interface IRaceTabProps {
    isReadOnly: boolean;
    raceList: IRpgRace[];
    selectedRace: IRpgRace | null;
    onSelectRace: (race: IRpgRace) => void;
    gender?: string;
}

const RaceTab: React.FC<IRaceTabProps> = ({
    isReadOnly,
    raceList,
    selectedRace,
    onSelectRace,
    gender,
}) => {
    const onRace_Select = (race: IRpgRace) => {
        if (isReadOnly) {
            return;
        }
        onSelectRace(race);
    };

    return (
        <div className="race-tab">
            <section className="race-tab__panel" aria-label="Race List">
                <div className="race-tab__panel-header">
                    <h3 className="race-tab__panel-title">Races</h3>
                    <p className="race-tab__panel-subtitle">{raceList.length} available</p>
                </div>

                <div className="race-tab__list">
                    {raceList.map((race) => {
                        const isSelected = selectedRace?.Id === race.Id;

                        return (
                            <RaceSelectionCard
                                isDisabled={isReadOnly}
                                key={race.Id}
                                race={race}
                                isSelected={isSelected}
                                gender={gender}
                                onSelect={onRace_Select}
                            />
                        );
                    })}
                </div>
            </section>

            <section className="race-tab__panel" aria-label="Race Details">
                <div className="race-tab__panel-header">
                    <h3 className="race-tab__panel-title">Race details</h3>
                </div>

                <div className="race-tab__details">
                    {selectedRace ? (
                        <RaceDetailsPanel race={selectedRace} />
                    ) : (
                        <div className="race-tab__details-empty">Select a race to see details.</div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default RaceTab;
